import { useAppSelector } from 'store'
import { ProfileSelectors } from 'store/pages/profile'

export const useTicketResaleData = () => useAppSelector(ProfileSelectors.ticketResaleData())
export const useTicketChangeNameData = () => useAppSelector(ProfileSelectors.ticketChangeNameData())
export const useTransactionData = () => useAppSelector(ProfileSelectors.transactionsData())
